import { useState } from "react"
import PropTypes from "prop-types"
import { Button, Dropdown } from "antd"
import { DownOutlined } from "@ant-design/icons"
import SendClientMessageModal from "ui/SendClientMessageModal"

// Recipient email/phone may live on a nested `user` (booking rows) or flat on the
// record itself (reservation rows), so check both shapes.
const recipientEmail = (recipient) => recipient?.user?.email || recipient?.email
const recipientPhone = (recipient) => recipient?.user?.phone_number || recipient?.phone

// Trigger button for messaging selected clients. Clicking it opens a channel menu
// (Email / Text); picking one opens ClientContactForm pre-set to that channel. A
// channel is disabled when none of the recipients has that contact method.
const SendMessageButton = ({ recipients, label, buttonProps, setSelectedRowKeys }) => {
  const [channel, setChannel] = useState(null)

  const channelItems = [
    { key: "email", label: "Email", disabled: !recipients.some(recipientEmail) },
    { key: "text", label: "Text (SMS)", disabled: !recipients.some(recipientPhone) }
  ]

  // Guard the handler too — `disabled` only hides the item visually; re-enabling it
  // via dev tools must not open a channel none of the recipients can receive.
  const handleChannelClick = ({ key }) => {
    if (channelItems.find((item) => item.key === key)?.disabled) return
    setChannel(key)
  }

  return (
    <>
      <Dropdown
        trigger={["click"]}
        menu={{ items: channelItems, onClick: handleChannelClick }}
      >
        <Button {...buttonProps}>
          {label} <DownOutlined />
        </Button>
      </Dropdown>
      {channel && (
        <SendClientMessageModal
          open={Boolean(channel)}
          onClose={() => setChannel(null)}
          recipients={recipients}
          type={channel}
          setSelectedRowKeys={setSelectedRowKeys}
        />
      )}
    </>
  )
}

SendMessageButton.propTypes = {
  recipients: PropTypes.arrayOf(
    PropTypes.shape({
      userId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      user: PropTypes.object
    })
  ),
  label: PropTypes.node.isRequired,
  buttonProps: PropTypes.object,
  setSelectedRowKeys: PropTypes.func
}

SendMessageButton.defaultProps = {
  recipients: [],
  buttonProps: {},
  setSelectedRowKeys: undefined
}

export default SendMessageButton
